import { createAction, props } from '@ngrx/store';
import { IDropDownList } from '@interfaces';
export const loadUserTypes = createAction('[UserTypes] Load UserTypes');
export const loadUserTypesSuccess = createAction(
  '[UserTypes] Load UserTypes Success',
  props<{ userTypes: IDropDownList[] }>(),
);
export const loadUserTypesFailure = createAction(
  '[UserTypes] Load UserTypes Failure',
  props<{ error: string }>(),
);
